<section class="component-tab component-tab--press component-tab--social-media tab--social-media">
	<div class="row">
		<div class="col-12 tab-title__col">
			<h2 class="tab__title" *ngIf="socialMediaData.social_media_title" [innerHtml]="socialMediaData.social_media_title"></h2>
		</div>
		<div class="col-12">
			<div class="row">
				<div class="col-12 col-md-9" *ngIf="socialMediaData.social_media_content">
					<div class="tabbed__intro entry-content">
						<div class="entry-content">
							<p [innerHtml]="socialMediaData.social_media_content"></p>
						</div>
					</div>
				</div>
				<div class="col-12">
					<div class="video-wrapper">
						<div class="embed-responsive embed-responsive-16by9" *ngIf="shareddata.showVideo">
							<iframe frameborder="0" height="315" width="560" [src]="shareddata.videoUrl" allowFullScreen="true" style="border:none;overflow:hidden"></iframe>
						</div>
						<div class="no-video-yet" *ngIf="socialMediaData.social_media_image && !shareddata.showVideo">
							<img src="{{ socialMediaData.social_media_image }}" alt="socialMediaData.social_media_title" class="img-responsive" />
						</div>
					</div>
					<div class="video-list__wrapper" *ngFor="let mdVal of mediaData">
						<div class="video-list__date">{{ mdVal.interval }}</div>
						<div class="video-list__repeater">
							<div class="masonry-section masonry-section-js row">
								<div class="col-12 col-sm-6 video-playing" *ngFor="let mval of mdVal.values">
									<a href="javascript:void(0);" routerLink="/event/{{ mval.val.slug }}" class="no__link">
										<div class="video-playing__time" *ngIf="mval.val.dayTime"><i class="icon-clock"></i> {{ mval.val.dayTime }}</div>
										<h4 *ngIf="mval.val.title" [innerHtml]="mval.val.title"></h4>
										<div class="livestreams__icons">
											<div class="livestreams__vimeo" *ngIf="mval.val.liveStreamProvider == 'vimeo'">
												<img src="./assets/img/livestreams__vimeo.png" alt="" class="img-responsive" />
											</div>
											<div class="livestreams__facebook" *ngIf="mval.val.liveStreamProvider == 'facebook'">
												<img src="./assets/img/livestreams__facebook.png" alt="" class="img-responsive" />
											</div>
										</div>
										<p *ngIf="mval.val.introduction" [innerHtml]="mval.val.introduction"></p>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>